import { createRoutine } from 'redux-saga-routines';

export const fetchClients = createRoutine('FETCH_CLIENTS');
export const fetchClient = createRoutine('FETCH_CLIENT');

export const fetchClientColumns = createRoutine('FETCH_CLIENT_COLUMNS');
export const fetchClientByBarcode = createRoutine('FETCH_CLIENT_BY_BARCODE');
